module.exports = __webpack_public_path__ + "img/gauze-close.f913d7cb.svg";